import { DEFAULT_EMPTY_CELL_VALUE } from "../../../config";
import { YieldType } from "../../../globalTypes";
import { validateYieldValue } from "../../../validators";
import { setErrorInSpecificYield } from "../../setErrorInSpecificYield";
import { editedYieldCellStyles } from "./";

export interface EditedData {
  ask?: string;
  bid?: string;
  isin: string;
  securityProducerId: string;
  securityName: string;
  quoteFeedName: string;
  quoteFeedId: string;
  row: number;
}

interface ValidateAndSetYieldValueArgs {
  yieldType: YieldType;
  yieldValue: string | number;
  relativeRow: number;
  editedSecurityData: EditedData;
  table: Excel.Table;
  relativeColumn: number;
}

export const validateAndSetYieldValue = async ({
  yieldType,
  yieldValue,
  relativeRow,
  editedSecurityData,
  table,
  relativeColumn,
}: ValidateAndSetYieldValueArgs) => {
  try {
    validateYieldValue(yieldValue);
    editedSecurityData[yieldType] = yieldValue.toString();
    editedYieldCellStyles({
      table,
      row: relativeRow,
      column: relativeColumn,
      updatedYield: yieldType,
    });
  } catch (error) {
    yieldValue !== DEFAULT_EMPTY_CELL_VALUE &&
      setErrorInSpecificYield({ yieldType, sentRow: relativeRow, setButtonToRetry: false });
    return false;
  }
  return true;
};
